export const titanPrompts = [
  {
    text: `I'm Searching for Equipment`,
    children: [
      {
        text: `Searching for New Equipment`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `Looking for Used Equipment`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `Current Deals & Offers`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `Need Financing Info`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `I Have a General Question `,
        parentText: "I'm Searching for Equipment"
      }
    ]
  },
  {
    text: `I'm Searching for Parts`,
    children: [
      {
        text: 'Order Parts',
        parentText: "I'm Searching for Parts"
      },
      {
        text: 'Parts Promotions',
        parentText: "I'm Searching for Parts"
      },
      {
        text: 'General Parts Questions',
        parentText: "I'm Searching for Parts"
      }
    ]
  },
  {
    text: `My Machine Needs Service`,
    children: [
      {
        text: 'Schedule Equipment Service',
        parentText: 'My Machine Needs Service'
      },
      {
        text: 'Uptime Maintenance',
        parentText: 'My Machine Needs Service'
      },
      {
        text: 'Equipment Repair Support',
        parentText: 'My Machine Needs Service'
      },
      {
        text: 'General Service Questions',
        parentText: 'My Machine Needs Service'
      }
    ]
  },
  {
    text: `Interested in Job Openings`,
    children: [
      {
        text: 'Diesel Careers',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Equipment Sales/Rental Careers',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Parts Sales Careers',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Dealership Management Careers',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Precision/Machine Control/Technology Careers',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Student Opportunities',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Corporate Careers',
        parentText: 'Interested in Job Openings'
      },
      {
        text: 'Other',
        parentText: 'Interested in Job Openings'
      }
    ]
  },
  {
    text: `Trade In`,
    children: [
      {
        text: `Request a Quote`,
        parentText: 'Trade In'
      },
      {
        text: `General Questions`,
        parentText: 'Trade In'
      }
    ]
  },
  {
    text: `Quick Question`,
    children: [
      {
        text: 'Store Locations & Contact Information',
        parentText: 'Quick Question'
      },
      {
        text: 'HR Questions',
        parentText: 'Quick Question'
      },
      {
        text: 'Investor Relations',
        parentText: 'Quick Question'
      },
      {
        text: 'Other',
        parentText: 'Quick Question'
      }
    ]
  }
]
